var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMingcuteTransferLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 5.33335C19.167 4.99351 19.2972 4.66664 19.5304 4.41952C19.7637 4.17241 20.0826 4.0237 20.4218 4.00379C20.7611 3.98387 21.0952 4.09425 21.3558 4.31237C21.6164 4.53049 21.7838 4.83989 21.824 5.17735L21.8333 5.33335V23.448L24.8906 20.3907C25.1306 20.1515 25.4526 20.0127 25.7912 20.0024C26.1298 19.992 26.4596 20.111 26.7137 20.335C26.9678 20.5591 27.1271 20.8714 27.1592 21.2086C27.1913 21.5459 27.0939 21.8827 26.8866 22.1507L26.776 22.276L21.6693 27.3827C20.784 28.2693 19.292 27.7013 19.1746 26.4987L19.1666 26.3453V5.33335ZM6.22398 11.6093C5.99441 11.3798 5.8565 11.0743 5.83613 10.7503C5.81575 10.4262 5.91431 10.1059 6.11331 9.84935L6.22398 9.72401L11.3306 4.61735C12.216 3.73068 13.708 4.29868 13.8253 5.50135L13.8333 5.65468L13.8333 26.6667C13.8329 27.0065 13.7028 27.3334 13.4695 27.5805C13.2362 27.8276 12.9174 27.9763 12.5781 27.9962C12.2389 28.0162 11.9048 27.9058 11.6442 27.6877C11.3836 27.4695 11.2161 27.1601 11.176 26.8227L11.1666 26.6667V8.55201L8.10931 11.6093C7.85927 11.8593 7.5202 11.9997 7.16664 11.9997C6.81309 11.9997 6.47401 11.8593 6.22398 11.6093Z",
    fill: "#3BE8A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.5 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteTransferLine);
export default __webpack_public_path__ + "static/media/mingcuteTransferLine.924d6ed70b44302a23173caef455beb7.svg";
export { ForwardRef as ReactComponent };